/**
 * #759 R — una renovación de Stripe sin cobrar, vista desde el cliente.
 *
 * Al fallar el cobro hay una semana de gracia (`graceUntil`): la app avisa con la fecha y se puede
 * seguir trabajando. Acabada la gracia sin pagar, el backend corta y manda a /billing/renewal. Lo
 * comparten el aviso (`RenewalGraceNotice`), la pantalla de pago y `UsageWarningBanner`, que se
 * aparta mientras dura este aviso.
 */

/** Evento que pide refrescar el consumo cuando la renovación ya está pagada. */
export const RENEWAL_PAID_EVENT = 'billing:renewal-paid';

/**
 * ¿La suscripción (la de /api/billing/usage) es una renovación de Stripe sin cobrar y aún en gracia?
 * Sin fecha de gracia cuenta como en gracia, igual que la puerta: no corta sin fecha.
 */
export function isRenewalInGrace(usage, now = new Date()) {
  if (usage?.source !== 'stripe' || usage?.status !== 'past_due') return false;
  return !usage.graceUntil || new Date(usage.graceUntil) >= now;
}

/** «22 de octubre» / «22 October». */
export function formatRenewalDeadline(iso, language = 'es') {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(language, { day: 'numeric', month: 'long' });
}
